<div class="result-page-header-container">
    <h1>
        <sirius-text-html
            class="header-title sir-text-style-title-xl-default"
            data-cy="header-title"
            [html]="
                (translations()?.resultPage?.headerTitle ?? '')
                    | interpolate: { userName: userName() }
            ">
        </sirius-text-html>
    </h1>
    <h2 class="header-subtitle sir-text-style-title-m-default" data-cy="header-subtitle">
        {{ translations()!.resultPage.headerSubTitle }}
    </h2>
    <sirius-text-html
        textStyleSize="l"
        class="header-description sir-text-style-paragraph-l-default"
        data-cy="header-description"
        [html]="translations()?.resultPage?.headerDescription ?? ''">
    </sirius-text-html>
</div>
